import {PerimetreFermetureDTO} from "./PerimetreFermetureDTO";

export class FermeturePonctuelleDTO {
  id = 0;
  idUniteProduction: number;
  libelle: string;
  code: string;
  dateFermeture: Date;
  perimetreFermetureList: PerimetreFermetureDTO[];
}
